<template>
    <div :key="iteration">
        <loading v-show="isLoading"></loading>

        <text-extended
            :classes="classes"
            :title="title"
            :sections="sections"
            :heading="title.heading"
        />
    </div>
</template>

<script>
    import ApiWidget from './ApiWidget';
    import Loading from "./Loading.vue";
    import TextExtended from "./TextExtended.vue";

    export default {
        extends: ApiWidget,
        components: {TextExtended, Loading},
        props: [
            'response'
        ],

        data() {
            return {
                title: {},
                sections: [],
                classes: 'text-widget',
            }
        },

        created() {
            this.registerParameterListeners([
                'fund',
                'investor',
                'portfolio',
                'range',
                'riskRated',
                'scheme',
                'searchString',
                'startDate',
                'endDate',
            ]);
        },

        methods: {
            async update(data) {
                if (data.display === 'none') {
                    return this.$el.closest('.page-widget').hidden = true;
                }

                this.title = this.retrieveTitle(data);
                this.sections = this.retrieveSections(data);
            }
        }
    }
</script>
